import { Button, CardContent, Grid, TextField, Typography, Divider, Autocomplete, Modal, Box, Select, MenuItem } from '@mui/material';
import ArrowBackSharpIcon from '@mui/icons-material/ArrowBackSharp';
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import HOST_URL from '../../../utils/Url';
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import nopdf from '../../../assets/images/nopdf.png'

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "180vh",
    height: "85vh",
    bgcolor: "#f5f5f5",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
};


type Props = {};

const DocumentEdit = (props: Props) => {

    const location = useLocation();
    console.log('location', location.state)





    let navigate = useNavigate();
    const { t } = useTranslation();

    const back = useNavigate();

    const requiredFields = ['doc_name'];

    const validationSchema = Yup.object({
        doc_name: Yup.string().test(
            'required',

            function (value: any) {
                return value && value.trim() !== '';
            }
        ),
    });

    const formik = useFormik({
        initialValues: {
            // doc_id: location.state.doc_id,
            pdfName: location.state.pdfName,
            doc_name: location.state.doc_name,
            doc_shortname: location.state.doc_shortname,
            session_year: location.state.session_year,
            member_type: location.state.member_type,
            hindNam: location.state.hindNam,
            user_id: location.state.user_id,
            inst_ID: location.state.inst_ID,
            allowedto: location.state.allowedto,

        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {

            const response = await axios.post(
                HOST_URL.HOST_URL + `document/AddUpdatedocument`,
                values
            );
            try {
                alert(response.data.mesg);
                navigate('/DocManagement/Document');
            } catch (error) {
                alert(response.data.mesg);
            }
        },
    });


    return (
        <div>
            <div
                style={{
                    padding: "-5px 5px",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    marginTop: "5px",
                    border: ".5px solid #FF7722",
                }}
            >
                <CardContent>
                    <Typography
                        variant="h5"
                        textAlign="center"
                        style={{ fontSize: "18px", fontWeight: 500 }}
                    >
                        Edit Doc Files
                    </Typography>

                    <Grid item sm={4} xs={12}>
                        <Typography style={{ marginTop: "-75px" }}>
                            <Button
                                type="submit"
                                onClick={() => back(-1)}
                                variant="contained"
                                style={{
                                    marginBottom: 15,
                                    marginTop: "45px",
                                    backgroundColor: "blue",
                                    width: 20,
                                }}
                            >
                                <ArrowBackSharpIcon />
                            </Button>
                        </Typography>
                    </Grid>
                    <Divider />
                    <br />
                    <form onSubmit={formik.handleSubmit}>
                        <Grid item xs={12} container spacing={2}>
                            <Grid md={4} item>
                                <TextField
                                    label={
                                        <span>
                                            Document Name{requiredFields.includes('doc_name') && (
                                                <span style={{ color: formik.values.doc_name ? 'green' : 'red' }}>*</span>
                                            )}
                                        </span>
                                    }
                                    value={formik.values.doc_name}
                                    placeholder="Document Name"
                                    size="small"
                                    fullWidth
                                    name="doc_name"
                                    id="doc_name"
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.doc_shortname && formik.errors.doc_shortname ? (
                                    <div style={{ color: "red", margin: "5px" }}>{String(formik.errors.doc_shortname)}</div>
                                ) : null}
                            </Grid>

                            <Grid md={4} item>
                                <TextField
                                    label="Document Shortname"
                                    value={formik.values.doc_shortname}
                                    placeholder="Document Shortname"
                                    size="small"
                                    fullWidth
                                    name="doc_shortname"
                                    id="doc_shortname"
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid md={4} item>
                                <TextField
                                    label="Session Year"
                                    value={formik.values.session_year}
                                    name="session_year"
                                    id="session_year"
                                    placeholder="Session Year"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                           

                            <Grid md={4} item>
                                <TextField
                                    label="Hint Name"
                                    value={formik.values.hindNam}
                                    name="hindNam"
                                    id="hindNam"
                                    placeholder="Hint Name"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>




                            <Grid item xs={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#059669",
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {t("text.save")}
                                    </Button>
                                </Grid>

                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="reset"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#F43F5E",
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                        onClick={(e) => formik.resetForm()}
                                    >
                                        {t("text.reset")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* </Card> */}
                    </form>
                </CardContent>
            </div>
        </div>
    );
};

export default DocumentEdit;
